import { useState, useEffect } from "react";
import T from "../constants/translations";

export function useSettings() {
  const [darkMode, setDarkMode] = useState(() => {
    try { return localStorage.getItem("dm") === "1"; } catch (e) { return false; }
  });
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("lang") || "ko"; } catch (e) { return "ko"; }
  });
  const [companionType, setCompanionType] = useState("");

  useEffect(() => {
    try { localStorage.setItem("dm", darkMode ? "1" : "0"); } catch (e) {}
  }, [darkMode]);

  useEffect(() => {
    try { localStorage.setItem("lang", lang); } catch (e) {}
  }, [lang]);

  const dm = darkMode;
  const t = T[lang] || T["ko"];

  return { darkMode, setDarkMode, lang, setLang, dm, t, companionType, setCompanionType };
}
